// LazyLoad - https://github.com/aFarkas/lazysizes
import 'lazysizes'
// import a plugin
import 'lazysizes/plugins/parent-fit/ls.parent-fit'

// Theme Functions
const fSmoothScroll = require('./utils/smooth-scroll')
import observeAndExecute from './utils/observe-and-execute';
const fCarousels = require('./components/carousels');
const fHeader = require('./components/header');
const fContentWithMedia = require('./components/content-with-media');
// const fSelect = require('./components/select');
const fGsapController = require('./components/gsap-controller')
const fCounterText = require('./components/counter-text')
import VueComponents from "./components/vue-components";

async function loadAOS() {
    const AOS = await (await import("aos")).default;
    AOS.init({
        once: true,
        offset: window.innerWidth >= 1024 ? -100 : 200,
        duration: 700,
    })
}

document.addEventListener('DOMContentLoaded', () => {
    fSmoothScroll()
    // fSelect.init()
    fHeader();
    fContentWithMedia();
    fCounterText();
    fGsapController.init()

    new VueComponents({
        components: [
            {name: 'map-section', file: () => import('./vue/features/map/map-section.vue')},
            {name: 'news', file: () => import('./vue/features/news/news.vue')},
            {name: 'story', file: () => import('./vue/features/story/story.vue')},
        ],
    });

    observeAndExecute("[data-aos]", {
        callback: () => loadAOS(),
        disconnect: true,
    })

    observeAndExecute(".swiper", {
        callback: () => fCarousels.init(),
        disconnect: true,
    })
    
    observeAndExecute(".video-autoplay", {
        callback: (el) => {
            const desktopSource = el.dataset.src;
            const mobileSource = el.dataset.mobileSrc;
            
            setSourceByResize();
            window.addEventListener("resize", setSourceByResize);
            
            el.addEventListener("play", () => {
                el.parentNode?.querySelector(".video-poster")?.remove();
            }, {once: true})

            function setSourceByResize() {
                const isMobile = window.innerWidth < 1024;
                const desiredSrc = isMobile && mobileSource ? mobileSource : desktopSource;

                if (el.currentSrc !== desiredSrc && el.src !== desiredSrc) {
                    el.src = desiredSrc;
                }
            }
        },
        disconnect: true,
    })
})